import { useParams } from 'react-router-dom';

import { useUserContext } from '@/Contexts/User';
import { AdminOrganisationLayout } from '@/new/pages/admin/organisations/_organisationId/admin-organisation-layout';
import { ActivityDashboard } from '@/new/pages/components/activity-dashboard';
import { BillingUsage } from '@/new/pages/components/billing-usage';

export function AdminOrganisationUsage({ section }: { section: 'activity' | 'usage' }) {
  const { organisationId } = useParams();
  const { user } = useUserContext();
  if (!organisationId) return null;

  const isViewingOtherOrg = organisationId !== user?.organisationId;

  return (
    <AdminOrganisationLayout>
      {section === 'activity' ? (
        <ActivityDashboard key={organisationId} organisationId={organisationId} isViewingOtherOrg={isViewingOtherOrg} />
      ) : (
        <BillingUsage key={organisationId} organisationId={organisationId} isViewingOtherOrg={isViewingOtherOrg} />
      )}
    </AdminOrganisationLayout>
  );
}
